<template>
  <div class="form-group row my-3 mb-3">
    <label
      v-if="label || $slots.label"
      :for="id"
      class="col-sm-4 col-lg-3 col-form-label"
    >
      <!-- Default label text -->
      <template v-if="!$slots.label">
        {{ label }}
        <span v-if="mandatory" class="mandatory">*</span>
      </template>

      <!-- Custom label slot -->
      <slot name="label" />
    </label>

    <div :class="label ? 'col-12 col-lg-9' : 'col-12'">
      <!-- Inject custom input via slot -->
      <!-- and add is-invalid class! -->
      <slot
        :class="
          $attrs.class && ($attrs.class as string).includes('is-invalid')
            ? 'is-invalid'
            : ''
        "
      />

      <!-- Optional help text -->
      <small v-if="helpText" class="float-right" style="font-size: x-small">
        {{ helpText }}
      </small>

      <!-- FieldErrorsFeedback (error messages from backend call) -->
      <FieldErrorsFeedback
        v-if="fieldErrors"
        :field-errors="fieldErrors"
        :input-field-name="name"
      />
      <!-- Validation errors from Vuelidate -->
      <template v-for="(msg, key) in validationMessages" :key="key">
        <div
          v-if="vField && vField[key] && vField[key]['$invalid']"
          class="invalid-feedback clear-both"
        >
          {{ msg }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import FieldErrorsFeedback from "~/components/shared/FieldErrorsFeedback.vue";
import type { FieldError } from "~/model/api/pLCnextStoreFrontendAPI.schemas";

defineProps({
  id: { type: String, required: true },
  name: { type: String, required: true },
  label: { type: String, required: false, default: "" },
  helpText: { type: String, default: "" },
  mandatory: { type: Boolean, default: false },

  /** Vuelidate object for this field */
  vField: {
    type: Object,
    default: () => ({}),
  },

  fieldErrors: {
    type: Array as () => FieldError[],
    default: () => [],
  },
  validationMessages: {
    type: Object,
    default: () => ({}),
  },
  className: {
    type: String,
    default: "",
  },
});
</script>
<style lang="scss" scoped>
@use "@/sass/components/FormField.scss" as *;
</style>
